// client/src/components/OrganiserCreateCard.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { refreshSessionUser } from '../lib/api';
import { isApprovedOrganiser } from '../lib/roles';

function getCachedUser() {
  try { return JSON.parse(sessionStorage.getItem('user')); } catch { return null; }
}

export default function OrganiserCreateCard({ user: userProp }) {
  const navigate = useNavigate();

  // ✅ state so UI can update after refreshSessionUser()
  const [user, setUser] = useState(userProp || getCachedUser());

  // ✅ if parent passes user later, keep in sync
  useEffect(() => {
    if (userProp) setUser(userProp);
  }, [userProp]);

  const approved = isApprovedOrganiser(user);
  const mode = approved ? 'approved' : 'pending';

  async function handleClick() {
    const fresh = await refreshSessionUser().catch(() => null);

    // refreshSessionUser might return { ok:true, user:{...} } or just user
    const u = fresh?.user ? fresh.user : fresh;

    const finalUser = u || user;
    if (finalUser) setUser(finalUser); // ✅ update banner immediately

    if (isApprovedOrganiser(finalUser)) navigate('/groups/new');
    else navigate('/groups/organiser-request');
  }

  return (
    <div
      className={`organiser-banner organiser-banner--${mode}`}
      role="region"
      aria-label={approved ? 'Organiser: approved to create groups' : 'Organiser approval required'}
    >
      <div className="organiser-banner__copy">
        <div className="organiser-banner__icon" aria-hidden>📝</div>
        <div>
          {approved ? (
            <>
              <h3 className="organiser-banner__title organiser-banner__title--approved">
                You’re approved to create groups
              </h3>
              <p className="organiser-banner__desc organiser-banner__desc--approved">
                Create your first group now and invite members.
              </p>
            </>
          ) : (
            <>
              <h3 className="organiser-banner__title organiser-banner__title--pending">
                Want to create groups?
              </h3>
              <p className="organiser-banner__desc organiser-banner__desc--pending">
                Request organiser approval first. We’ll notify you when it’s approved.
              </p>
            </>
          )}
        </div>
      </div>

      <button
        type="button"
        className={`btn organiser-banner__cta ${approved ? 'btn--green' : 'btn--primary'}`}
        onClick={handleClick}
      >
        {approved ? 'Create a Group' : 'Request Approval'}
      </button>
    </div>
  );
}
